function checkFields(arFields) {
	var
		error = 0,
		id,
		val,
		valLength,
		def,
		select,
		show,
		checkLength,
		id2;

	for (var field in arFields) {
		id = arFields[field]['id'];
		val = $(id).val();
		valLength	= val.length;
		def = arFields[field]['default'];
		select = arFields[field]['select'];
		show = arFields[field]['show'];
		checkLength	= arFields[field]['checkLength'];

		switch (arFields[field]['type']) {
			case 'text':
				if (!empty(select) && $(id).is(':visible')) {
					if (empty(val) || val == def) {
						$(select).addClass('error-data');
						error++;
					} else if (!empty(checkLength) && valLength < checkLength) {
						$(select).addClass('error-data');
						error++;
					} else {
						$(select).removeClass('error-data');
					}
				} else if ($(id).is(':visible')) {
					if (empty(val) || val == def) {
						$(id).addClass('error-data');
						error++;
					} else if (!empty(checkLength) && valLength < checkLength) {
						$(id).addClass('error-data');
						error++;
					} else {
						$(id).removeClass('error-data');
					}
				}
			break;

			case 'email':
				if (empty(val) || val == def || !checkEmail(val)) {
					$(id).addClass('error-data');
					error++;
				} else {
					$(id).removeClass('error-data');
				}
			break;

			case 'captcha':
				$.ajaxSetup({async: false});
				$.get('/local/modules/zebra.artools/tools/check_captcha.php',
					'captcha_sid=' + arFields[field]['sid'] + '&captcha_word=' + arFields[field]['word'], function (response) {
					if (empty(val) || val == def || response == 0) {
						$(id).addClass('error-data');
						error++;
					} else if (response == 1) {
						$(id).removeClass('error-data');
					}
				});
				$.ajaxSetup({async: true});
			break;
		}
	}
	return error;
}

module.exports = checkFields;



/** WEBPACK FOOTER **
 ** ./frontend/components/error-report/checkfields.js
 **/